export default "__VITE_ASSET__DOkiVrE6__"